// Designed confirm — Field Notes replacement for the native browser
// confirm dialog (which is banned by src/test/no-native-dialogs.test.js).
// Promise API: const ok = await confirm({title, body, confirmLabel, danger}).
// One provider at the app root; call sites stay one-liners.
import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import './ConfirmDialog.css';

const ConfirmContext = createContext(null);

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used inside <ConfirmProvider>');
  return ctx;
}

export function ConfirmProvider({ children }) {
  const [req, setReq] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      resolver.current = resolve;
      setReq(options || {});
    });
  }, []);

  const settle = (value) => {
    setReq(null);
    if (resolver.current) {
      resolver.current(value);
      resolver.current = null;
    }
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {req && (
        <div className="confirm-scrim" onClick={() => settle(false)}>
          <div
            className="confirm-card rise"
            role="dialog"
            aria-modal="true"
            aria-label={req.title}
            tabIndex={-1}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => { if (e.key === 'Escape') settle(false); }}
            ref={(el) => el && el.focus()}
          >
            <div className="confirm-title">{req.title}</div>
            {req.body && <div className="confirm-body">{req.body}</div>}
            <div className="confirm-actions">
              <button type="button" className="fn-btn" onClick={() => settle(false)}>
                {req.cancelLabel || 'Cancel'}
              </button>
              <button
                type="button"
                className={'fn-btn fn-btn-primary' + (req.danger ? ' is-danger' : '')}
                onClick={() => settle(true)}
              >
                {req.confirmLabel || 'Confirm'}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}
